import { useEffect, useState } from 'react';
import '../../../../common/css/style.css';

export const FloatingCta = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <a
      href="/#contacts"
      className={`floating-cta ${visible ? 'floating-cta-visible' : ''}`}
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
    >
      Записатись
    </a>
  );
};
